'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Services


// Components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _userService = require('../../../../user/userService');

var _PopupEmptyContent = require('../../../../components/popupPanel/PopupEmptyContent');

var _PopupEmptyContent2 = _interopRequireDefault(_PopupEmptyContent);

var _RetryErrorComponent = require('../../../../components/error/RetryErrorComponent');

var _RetryErrorComponent2 = _interopRequireDefault(_RetryErrorComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchFetchUsers: function dispatchFetchUsers(userIds) {
            return dispatch((0, _userService.fetchUsers)(userIds, true));
        }
    };
};

var PopupUserErrorEmptyContent = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(PopupUserErrorEmptyContent, _React$Component);

    function PopupUserErrorEmptyContent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PopupUserErrorEmptyContent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupUserErrorEmptyContent.__proto__ || Object.getPrototypeOf(PopupUserErrorEmptyContent)).call.apply(_ref, [this].concat(args))), _this), _this.retry = function () {
            var _this$props = _this.props,
                userIds = _this$props.userIds,
                dispatchFetchUsers = _this$props.dispatchFetchUsers;

            dispatchFetchUsers(userIds);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PopupUserErrorEmptyContent, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _PopupEmptyContent2.default,
                null,
                _react2.default.createElement(_RetryErrorComponent2.default, { message: 'There was a problem loading users', retryFn: this.retry })
            );
        }
    }]);

    return PopupUserErrorEmptyContent;
}(_react2.default.Component)) || _class);


PopupUserErrorEmptyContent.propTypes = {
    userIds: _propTypes2.default.array,
    dispatchFetchUsers: _propTypes2.default.func
};

exports.default = PopupUserErrorEmptyContent;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/common/PopupUserErrorEmptyContent.js
// module id = 777
// module chunks = 0